import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'

export const SpacerBlockFragment: BlockFragment = {
  name: 'spacer',
  fragment: gql`
    fragment spacer on Spacer {
      id
      blockName
      blockType
      adjustment
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Spacer {
      id
      blockName
      blockType
      adjustment
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const SpacerBlockType = 'spacer'

export interface SpacerBlock extends BaseBlock {
  blockType: typeof SpacerBlockType
  adjustment: number
}
